import React, { memo } from 'react';
import { useIntl } from 'react-intl';

import { User } from '../../types/User';
import { getUserName } from '../../utils/getUserName';
import { TruncateText } from '../Text/subcomponents/TruncateText';
import { Text } from '../Text/Text';
import { Tooltip } from '../Tooltip/Tooltip';
import { UserNameOptions } from './types';

interface Props {
  user?: User;
  mode?: 'info' | 'name' | 'full';
  options?: UserNameOptions;
  placeholder?: string;
}

export const UserName = memo(
  ({
    mode = 'info',
    options = {},
    user,
    placeholder: initialPlaceholder,
  }: Props) => {
    const intl = useIntl();
    const {
      isCurrentUser = false,
      isDeleted = false,
      shouldAbbreviateLastName,
      shouldTruncate = true,
    } = options;

    const placeholder = initialPlaceholder
      ? initialPlaceholder
      : intl.formatMessage({
          id: 'UserName.placeholder',
          defaultMessage: 'Unknown User',
          description:
            'Placeholder text for user info when no user data is available',
        });

    const TextComponent = shouldTruncate ? TruncateText : Text;
    return (
      <Tooltip tooltip={user?.email}>
        <TextComponent
          whiteSpace="nowrap"
          variant={mode !== 'full' ? 'body-bold' : 'body'}
        >
          {user
            ? getUserName({
                user,
                options: {
                  shouldAbbreviateLastName,
                  isDeleted,
                  isCurrentUser,
                },
                intl,
              })
            : placeholder}
        </TextComponent>
      </Tooltip>
    );
  },
);
